// extracted by mini-css-extract-plugin
module.exports = {"draggableTableHeader":"CourseList_draggableTableHeader_hVFhz","maxContentNoWrap":"CourseList_maxContentNoWrap_1kMxU","minWidthNoWrap":"CourseList_minWidthNoWrap_24kfu"};